import { masterAPIClient } from '@/clients/MasterAPIClient';
import { IMerchandise } from '@/data/models/format';
import { IOptions } from '@/data/models/option';
import { useQuery, UseQueryResult } from '@tanstack/react-query';

export default function useGetMerchandiseTypesQuery(
  formatId?: number | null
): UseQueryResult<IOptions<IMerchandise>[], Error> {
  return useQuery({
    queryKey: ['merchandiseTypes', formatId],
    queryFn: () => masterAPIClient.getMerchandiseTypes(formatId ?? null),
    staleTime: 10000,
  });
}
